export const FEDERAL_STATES: { state: string, name: string }[] = [
  {
    state: 'Baden-Württemberg',
    name: $localize`:@@federal-state-baden-württemberg:Baden-Württemberg`,
  },
  {
    state: 'Bayern',
    name: $localize`:@@federal-state-bavaria:Bayern`,
  },
  {
    state: 'Berlin',
    name: $localize`:@@federal-state-berlin:Berlin`,
  },
  {
    state: 'Brandenburg',
    name: $localize`:@@federal-state-brandenburg:Brandenburg`,
  },
  {
    state: 'Bremen',
    name: $localize`:@@federal-state-bremen:Bremen`,
  },
  {
    state: 'Hamburg',
    name: $localize`:@@federal-state-hamburg:Hamburg`,
  },
  {
    state: 'Hessen',
    name: $localize`:@@federal-state-hesse:Hessen`,
  },
  {
    state: 'Mecklenburg-Vorpommern',
    name: $localize`:@@federal-state-mecklenburg-vorpommern:Mecklenburg-Vorpommern`,
  },
  {
    state: 'Niedersachsen',
    name: $localize`:@@federal-state-lower-saxony:Niedersachsen`,
  },
  {
    state: 'Nordrhein-Westfalen',
    name: $localize`:@@federal-state-north-rhine-westphalia:Nordrhein-Westfalen`,
  },
  {
    state: 'Rheinland-Pfalz',
    name: $localize`:@@federal-state-rhineland-palatinate:Rheinland-Pfalz`,
  },
  {
    state: 'Saarland',
    name: $localize`:@@federal-state-saarland:Saarland`,
  },
  {
    state: 'Sachsen',
    name: $localize`:@@federal-state-saxony:Sachsen`,
  },
  {
    state: 'Sachsen-Anhalt',
    name: $localize`:@@federal-state-saxony-anhalt:Sachsen-Anhalt`,
  },
  {
    state: 'Schleswig-Holstein',
    name: $localize`:@@federal-state-schleswig-holstein:Schleswig-Holstein`,
  },
  {
    state: 'Thüringen',
    name: $localize`:@@federal-state-thuringia:Thüringen`,
  },
];

export const INSTITUTION_KINDS: { kind: string, name: string }[] = [
  {
    kind: 'Fachhochschule',
    name: $localize`:@@institution-kind-university-of-applied-sciences:Fachhochschule`,
  },
  {
    kind: 'Universität',
    name: $localize`:@@institution-kind-university:Universität`,
  },
  {
    kind: 'außeruniversitäre Forschungseinrichtung',
    name: $localize`:@@institution-kind-non-university-research-institution:außeruniversitäre Forschungseinrichtung`,
  },
  {
    kind: 'Firma',
    name: $localize`:@@institution-kind-company:Firma`,
  },
];

export const INSTITUTION_SIZES: { size: string, name: string }[] = [
  {
    size: 'Klein',
    name: $localize`:@@institution-size-small:Klein`,
  },
  {
    size: 'Mittel',
    name: $localize`:@@institution-size-medium:Mittel`,
  },
  {
    size: 'Big',
    name: $localize`:@@institution-size-big:Groß`,
  },
];
